// extracted by mini-css-extract-plugin
module.exports = {"menu-view__title":"t_bf my-2 p-2","menu-view__tile-row":"t_bg d-flex"};